/* Aero: „Kombinieren & Sparen“. Überträgt die gewählte Menge ins Produktformular
   (Dawn und PagePilot) und rechnet die Preise bei Variantenwechsel neu.
   Bei 2 Stück mit verschiedenen Varianten wird das 2. Stück vor dem normalen Kauf
   zusätzlich in den Warenkorb gelegt, der normale Kauf läuft dann mit Menge 1. */
if (!customElements.get('aero-quantity-breaks')) {
  customElements.define(
    'aero-quantity-breaks',
    class AeroQuantityBreaks extends HTMLElement {
      connectedCallback() {
        this.form = document.getElementById(this.dataset.formId);
        try {
          this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
        } catch (e) {
          this.variants = [];
        }
        this.secondSelect = this.querySelector('[data-second-variant]');
        this.secondTouched = false;

        this.querySelectorAll('.aero-qb__radio').forEach((radio) => {
          radio.addEventListener('change', () => this.applyQuantity());
        });
        if (this.secondSelect) {
          this.secondSelect.addEventListener('change', (event) => {
            event.stopPropagation();
            this.secondTouched = true;
            this.updatePrices();
          });
        }

        // Dawn und PagePilot setzen die neue Variante erst nach einem Server-Abruf ins Formular
        // (bis ca. 1 s). Deshalb nach jeder Änderung kurz beobachten statt einmal zu lesen.
        this.lastVariantId = this.currentVariantId();
        this.onDocumentChange = () => this.watchVariant();
        document.addEventListener('change', this.onDocumentChange);

        this.onBuyClick = (event) => this.handleBuyClick(event);
        document.addEventListener('click', this.onBuyClick, true);

        this.applyQuantity();
      }

      disconnectedCallback() {
        document.removeEventListener('change', this.onDocumentChange);
        document.removeEventListener('click', this.onBuyClick, true);
        clearInterval(this.watchTimer);
      }

      currentVariantId() {
        this.form = document.getElementById(this.dataset.formId) || this.form;
        const idInput = this.form && this.form.querySelector('input[name="id"], select[name="id"]');
        return idInput ? String(idInput.value) : null;
      }

      watchVariant() {
        clearInterval(this.watchTimer);
        const started = Date.now();
        this.watchTimer = setInterval(() => {
          const id = this.currentVariantId();
          if (id !== this.lastVariantId) {
            this.lastVariantId = id;
            this.updatePrices();
          }
          if (Date.now() - started > 3000) clearInterval(this.watchTimer);
        }, 100);
      }

      selectedQuantity() {
        const checked = this.querySelector('.aero-qb__radio:checked');
        return checked ? parseInt(checked.value, 10) : 1;
      }

      quantityInputs() {
        if (!this.form) return [];
        const inside = [...this.form.querySelectorAll('input[name="quantity"]')];
        const linked = this.form.id ? [...document.querySelectorAll(`input[name="quantity"][form="${this.form.id}"]`)] : [];
        return [...new Set([...inside, ...linked])];
      }

      setQuantity(qty) {
        if (!this.form) return;
        let inputs = this.quantityInputs();
        if (inputs.length === 0) {
          const hidden = document.createElement('input');
          hidden.type = 'hidden';
          hidden.name = 'quantity';
          this.form.appendChild(hidden);
          inputs = [hidden];
        }
        inputs.forEach((input) => {
          input.value = qty;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      applyQuantity() {
        this.setQuantity(this.selectedQuantity());
      }

      currentVariant() {
        const id = this.currentVariantId();
        return (id && this.variants.find((v) => String(v.id) === id)) || null;
      }

      secondVariant(first) {
        if (!this.secondSelect) return first;
        return this.variants.find((v) => String(v.id) === this.secondSelect.value) || first;
      }

      updatePrices() {
        const first = this.currentVariant();
        if (!first) return;

        // 2. Stück folgt der oberen Auswahl, bis der Kunde es selbst ändert
        if (this.secondSelect) {
          this.querySelector('[data-first-variant]').textContent = first.title;
          const option = this.secondSelect.querySelector(`option[value="${first.id}"]`);
          if (!this.secondTouched && option && !option.disabled) this.secondSelect.value = String(first.id);
        }
        const second = this.secondVariant(first);

        this.querySelectorAll('.aero-qb__option').forEach((option) => {
          const qty = parseInt(option.querySelector('.aero-qb__radio').value, 10);
          const items = qty >= 2 ? [first, second] : [first];
          let total = items.reduce((sum, v) => sum + v.price, 0);
          const compareTotal = items.reduce((sum, v) => sum + Math.max(v.compare || 0, v.price), 0);
          if (qty >= 2 && this.dataset.mode === 'fixed') total = Math.max(total - 1000, 0);
          if (qty >= 2 && this.dataset.mode === 'percent') total = Math.floor((total * 90) / 100);
          option.querySelector('[data-price]').textContent = this.formatMoney(total);
          const compare = option.querySelector('[data-compare]');
          compare.textContent = this.formatMoney(compareTotal);
          compare.hidden = compareTotal <= total;
        });
      }

      async handleBuyClick(event) {
        if (this.bypass || !this.form) return;
        const button = event.target.closest('[type="submit"]');
        if (!button || button.form !== this.form) return;
        if (this.selectedQuantity() !== 2 || !this.secondSelect) return;

        const first = this.currentVariant();
        const second = first && this.secondVariant(first);
        if (!first || !second || first.id === second.id) return;

        // Verschiedene Varianten: 2. Stück zuerst still hinzufügen, dann normaler Kauf mit Menge 1
        event.preventDefault();
        event.stopImmediatePropagation();
        const error = this.querySelector('[data-mix-error]');
        error.hidden = true;

        try {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: second.id, quantity: 1 }] }),
          });
          if (!response.ok) throw new Error('add failed');
        } catch (e) {
          error.hidden = false;
          return;
        }

        this.setQuantity(1);
        this.bypass = true;
        button.click();
        this.bypass = false;
        setTimeout(() => this.applyQuantity(), 2000);
      }

      formatMoney(cents) {
        const format = this.dataset.moneyFormat || '{{amount_with_comma_separator}}€';
        const value = (cents / 100).toFixed(2);
        const [whole, decimals] = value.split('.');
        const withSep = (sep) => whole.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
        return format.replace(/\{\{\s*(\w+)\s*\}\}/, (match, key) => {
          switch (key) {
            case 'amount_with_comma_separator':
              return `${withSep('.')},${decimals}`;
            case 'amount_no_decimals':
              return withSep(',');
            case 'amount_no_decimals_with_comma_separator':
              return withSep('.');
            default:
              return `${withSep(',')}.${decimals}`;
          }
        });
      }
    }
  );
}
